import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '@/api/axios';
import { Loader2, Copy, QrCode, Check, Share2 } from 'lucide-react';

const ORIGIN = window.location.origin;
const GRUPOS = [
  { nombre: '🛒 Tienda en Línea y Página Web', cats: ['Tienda en Línea', 'Página Web'] },
  { nombre: '🌐 Landing Pages', cats: ['Landing Page'] },
];

const TarjetaShare = ({ item }) => {
  const [copiado, setCopiado] = useState(false);
  const shareUrl = `${ORIGIN}/api/landing/share/${item.slug}`;
  const qrUrl = `${ORIGIN}/api/landing/qr/${item.slug}`;
  const waText = encodeURIComponent(`${item.titulo}\n${item.desc}\n👉 ${shareUrl}`);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = shareUrl;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopiado(true);
    toast.success('Link copiado. Pégalo donde quieras compartirlo.');
    setTimeout(() => setCopiado(false), 2000);
  };

  const descargarQR = () => {
    const a = document.createElement('a');
    a.href = qrUrl;
    a.download = `QR_${item.slug}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    toast.success('Descargando código QR…');
  };

  return (
    <div className="border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden bg-white dark:bg-slate-800/50 flex flex-col" data-testid={`share-card-${item.slug}`}>
      <div className="h-32 bg-slate-100 dark:bg-slate-700 overflow-hidden">
        <img src={item.imagen} alt={item.titulo} loading="lazy" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
      </div>
      <div className="p-3 flex-1 flex flex-col">
        <p className="font-black text-sm leading-tight">{item.titulo}</p>
        <p className="text-[11px] opacity-60 mt-1 line-clamp-2 flex-1">{item.desc}</p>
        <p className="text-[10px] font-mono opacity-50 mt-2 truncate" data-testid={`share-url-${item.slug}`}>{shareUrl}</p>
        <div className="flex gap-1.5 mt-2.5">
          <button onClick={copiar} data-testid={`share-copy-${item.slug}`}
            className="flex-1 flex items-center justify-center gap-1 text-[11px] font-bold px-2 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white transition-colors">
            {copiado ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {copiado ? 'Copiado' : 'Copiar link'}
          </button>
          <button onClick={descargarQR} data-testid={`share-qr-${item.slug}`}
            className="flex items-center justify-center gap-1 text-[11px] font-bold px-2.5 py-2 rounded-lg border border-slate-300 dark:border-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
            <QrCode className="w-3.5 h-3.5" /> QR
          </button>
          <button onClick={() => window.open(`https://wa.me/?text=${waText}`, '_blank')} data-testid={`share-wa-${item.slug}`}
            className="flex items-center justify-center gap-1 text-[11px] font-bold px-2.5 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white transition-colors">
            <Share2 className="w-3.5 h-3.5" /> WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default function Compartir() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get('/landing/share-items')
      .then(({ data }) => setItems(data.items || []))
      .catch(() => toast.error('No se pudieron cargar los links'));
  }, []);

  if (!items) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-blue-500" /></div>;

  return (
    <div className="space-y-6 max-w-6xl" data-testid="compartir-page">
      <div>
        <h1 className="text-xl font-black">📲 Compartir Links y QR</h1>
        <p className="text-xs opacity-60 mt-1">Copia el link, descarga el código QR o comparte por WhatsApp la tienda, la página web y las landing pages. Los links incluyen vista previa con imagen al compartirlos en redes.</p>
      </div>
      {GRUPOS.map((g) => {
        const grupo = items.filter((it) => g.cats.includes(it.categoria));
        if (!grupo.length) return null;
        return (
          <div key={g.nombre}>
            <p className="font-black text-xs uppercase tracking-wider opacity-70 mb-2">{g.nombre}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {grupo.map((it) => <TarjetaShare key={it.slug} item={it} />)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
